'use strict';

class Nav {
    constructor() {
        var elems = document.querySelectorAll('.sidenav');
        var instances = M.Sidenav.init(elems, {});

        elems = document.querySelectorAll('.dropdown-trigger')
        instances = M.Dropdown.init(elems, {
            'constrainWidth': false,
            'coverTrigger': false,
            'alignment': 'right'
        });
    }
}

export default new Nav;
